

export const networkMainnet =
{
    MATIC: {

        singleContract: "0x661a9A8C68e301AC1B0C4d005A5c1c748fb57B5C".toLowerCase(),
        multipleContract: "0xf15671815E027CB01FF81Fa4892F2f3Ad1701C42".toLowerCase(),
        TradeContract: "0x97CeC706481a2f53Ea6C607ECd4A1b4292b06272".toLowerCase(),
        FractionTradeContract: "0xD1F5f1E6Aa5B920c2383c30a4eDDF793De4433FF".toLowerCase(),
        Fraction721Contract: "0x87A8B63322AcaE46d84aa2Fe64ba2Ac5D2f3F25b".toLowerCase(),
        BNBPROVIDER: "https://polygon-mainnet.infura.io/v3/a6738b5a17514327ae8c9afc47b6179c",
        Bscscan: "https://polygonscan.com/",
        RPC_URL: "https://polygon-mainnet.infura.io/v3/a6738b5a17514327ae8c9afc47b6179c",
        networkVersion: '137',
        chainId: '137',
        Chainid: 137,
    },
    ETH: {

        singleContract: "0x661a9A8C68e301AC1B0C4d005A5c1c748fb57B5C".toLowerCase(),
        multipleContract: "0x8A27A94819c20E41bd5D9Beb16B011F1c2A59FF2".toLowerCase(),
        TradeContract: "0x43fe0E2c52B55eF0B9A375FcD02E1681Fb0102B8".toLowerCase(),
        FractionTradeContract: "0x2dB55028F8FcDF760828925C9773697c53B33658".toLowerCase(),
        Fraction721Contract: "0x77c4Bd0CE8806Ae7d9067df3b991Da42f32f99aF".toLowerCase(),
        BNBPROVIDER: "https://mainnet.infura.io/v3/a6738b5a17514327ae8c9afc47b6179c",
        Bscscan: "https://etherscan.io/",
        RPC_URL: "https://mainnet.infura.io/v3/a6738b5a17514327ae8c9afc47b6179c",
        networkVersion: '1',
        chainId: '0x1',
        Chainid: 1,

    },
    CAM: {

        singleContract: "0x099d05Bab09B157631b3A46B3838Bb10b8158D48".toLowerCase(),
        multipleContract: "0xA134bD01a5e6378C684C3492DEf6D09Bd542fC43".toLowerCase(),
        TradeContract: "0x64c7cFB5956DeE2b56973fd2CFF2bDb947b778d1".toLowerCase(),
        FractionTradeContract: "0xd39710d0660892E8C15cd5D0FCa4AF6306359c92".toLowerCase(),
        Fraction721Contract: "0x384Ab92c435C657f58b9fb094c0c063ea68D6e21".toLowerCase(),
        BNBPROVIDER: "https://api.camino.network/ext/bc/C/rpc",
        Bscscan: "https://caminoscan.com/",
        RPC_URL: "https://api.camino.network/ext/bc/C/rpc",
        networkVersion: '500',
        chainId: '0x1f4',
        Chainid: 500,

    }


}

export const network =
{
    MATIC: {

        singleContract: "0x67eE1331fc74A4eD8e0FcC21d04571124BEDf1C1".toLowerCase(),
        multipleContract: "0x4802036D8d9459a705b490D7980Eb3a61fDa06CE".toLowerCase(),
        TradeContract: "0xD87ddfE179fE3e2Aea84041118a7E6C7EC975fe3".toLowerCase(),
        FractionTradeContract: "0x037f3cdcA193C203Bc58923C841323916C4f8b0C".toLowerCase(),
        Fraction721Contract: "0x06b933041d79fCb156BffC28f5f965B76fC9bc6d".toLowerCase(),
        BNBPROVIDER: "https://rpc-amoy.polygon.technology",
        Bscscan: "https://www.oklink.com/amoy",
        RPC_URL: "https://rpc-amoy.polygon.technology",
        networkVersion: '80002',
        chainId: '80002',
        Chainid: 80002,
    },
    ETH: {

        singleContract: "0xb146C641600fB409DbF0Da87F9d301306f1ad429".toLowerCase(),
        multipleContract: "0x49adbBECA2DEcA481C8bA93E0cF15b7dBaebc019".toLowerCase(),
        TradeContract: "0x6621c25493112E20D1Bc0e433c6C2E0541ec1600".toLowerCase(),
        FractionTradeContract: "0x0F2b51c950eD407E7B1047713b8600CaF3209f6F".toLowerCase(),
        Fraction721Contract: "0x96b83d2Eb78048EF990F476C78b286584E50CAFf".toLowerCase(),
        BNBPROVIDER: "https://sepolia.infura.io/v3/b1b3f95471bb4a728aa9558e6f1ab569",
        Bscscan: "https://sepolia.etherscan.io/",
        RPC_URL: "https://sepolia.infura.io/v3/b1b3f95471bb4a728aa9558e6f1ab569",
        networkVersion: '11155111',
        chainId: '0xaa36a7',
        Chainid: 11155111,

    },
    CAM: {

        singleContract: "0xfA4a969786DC184917D99E63b84463df755aa8de".toLowerCase(),
        multipleContract: "0x384Ab92c435C657f58b9fb094c0c063ea68D6e21".toLowerCase(),
        TradeContract: "0xF8e83A035B5295101aEd5f9bb52692abbB27D180".toLowerCase(),
        FractionTradeContract: "0xceB10Da8499444C24C7aaB966716D7d141B8CDf5".toLowerCase(),
        Fraction721Contract: "0xe16C72246E95D44F9aCE3A2938F259dd3D7b40Df".toLowerCase(),
        BNBPROVIDER: "https://columbus.camino.network/ext/bc/C/rpc",
        Bscscan: "https://columbus.caminoscan.com/",
        RPC_URL: "https://columbus.camino.network/ext/bc/C/rpc",
        networkVersion: '501',
        chainId: '0x1f5',
        Chainid: 501,

    }


}